// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"arrowsFilter__wrapper","btn-dngr":"arrowsFilter__btn-dngr","pr-12":"arrowsFilter__pr-12","ico":"arrowsFilter__ico","active":"arrowsFilter__active"};